var _this = this;
import { bindActionCreators } from 'redux';
import { connect } from '../../../common/react-redux';
import { createItem } from '../../../building/api/items';
import { createStimulus } from '../../../building/api/stimuli';
import { toggle, set, clear } from '../../../common/actions/ui';
import * as modalActions from '../../../common/actions/modal';
import BankEntryRow from './presenter';
import * as bankEntryApiActions from '../../api/bankEntries';
import { screenreaderNotification } from '../../../common/actions/alerts';
import { featureOn } from '../../../common/util/featureCheck';
import { BUILD_TRAY_POSITION, BUILD_TRAY_STIMULUS_ID, SET_EDIT_BUTTON_FOCUS } from '@instructure/quiz-common';
var rowKey = function rowKey(props) {
  return "BANK_ENTRY_".concat(props.bankEntry.get('id'), "_EXPANDED");
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    activeQuizId: state.getIn(['quizzes', 'activeQuizId']),
    isExpanded: !!state.getIn(['ui', rowKey(props)]),
    position: state.getIn(['ui', BUILD_TRAY_POSITION]),
    stimulusId: state.getIn(['ui', BUILD_TRAY_STIMULUS_ID]),
    setEditButtonFocus: state.getIn(['ui', SET_EDIT_BUTTON_FOCUS]),
    tagAssociations: state.getIn(['tagAssociations', props.bankEntry.entry.get('schema'), props.bankEntry.entry.get('id')]),
    useBankTags: featureOn('item_bank_tagging')
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  return {
    clearUi: bindActionCreators(clear, dispatch),
    createItem: bindActionCreators(createItem, dispatch),
    createStimulus: bindActionCreators(createStimulus, dispatch),
    openModal: bindActionCreators(modalActions.openModal, dispatch),
    removeBankEntry: bindActionCreators(bankEntryApiActions.removeBankEntry, dispatch),
    screenreaderNotification: bindActionCreators(screenreaderNotification, dispatch),
    setUi: bindActionCreators(set, dispatch),
    toggleExpanded: bindActionCreators(toggle.bind(_this, rowKey(props)), dispatch),
    withConfirm: bindActionCreators(modalActions.withConfirm, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(BankEntryRow);